import { Paper } from '@mui/material';
import { SiTrackPage } from '../../components/si-track-page';
import { BulkScheduling } from './bulk-scheduling.component';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '10px' },
};

export const BulkSchedulingPage = () => {
  return (
    <SiTrackPage title="BULK SCHEDULING">
      <div className="innerContent noOuterBg">
        <Paper elevation={0} style={{ paddingLeft: '16px' }}>
          <BulkScheduling />
        </Paper>
      </div>
    </SiTrackPage>
  );
};
